<ng-container *ngIf="(cmsLabels$ | async)?.labels?.stellar?.ok && ((isServerDown$ | async) || showFlashPage) && (isStatesResolved$ | async); else displayUI">
    <app-service-unavailable
      [labels]="(cmsLabels$ | async)?.labels"
    ></app-service-unavailable>
</ng-container>
<ng-template #displayUI>
    <!-- Todo: Tim: *ngIf to check if labels are populated yet. Quick fix for issue where langSelector was trying to read before they were loaded, causing console errors. Should look at this again later to see if there is a better fix. -->
    <ng-container *ngIf="(cmsLabels$ | async)?.labels?.stellar?.ok && !(isServerDown$ | async) && (isStatesResolved$ | async)">
        <div class="min-h-dvh w-full max-w-[636px] !overflow-x-hidden">
            <div class="flex flex-col justify-center w-full h-full px-6">
                <div>
                    <app-sign-in-header [cmsLabels$]="cmsLabels$" [languageList]="languageList" [displayBackButton]="displayBackButton()" (backButtonClickEvent)="handleBackButton()"></app-sign-in-header>
                </div>
                <!-- TODO: TIM: Should the linear be set to true? -->
                <ng-container *ngIf="(hasError$ | async) || showFlashPage || (isServerDown$ | async); else anchorUI">
                </ng-container>
                <ng-template #anchorUI>
                    <mat-stepper
                        orientation="horizontal"
                        #stepper
                        [linear]="false"
                        class="h-full"
                    >
                        <mat-step>
                            <app-login-register
                            (signInClickEvent)="handleLoginRegister($event)"
                            (continueClickEvent)="navigateToTransactionFlow()"
                            ></app-login-register>
                        </mat-step>
                        <mat-step>
                            <app-request-otp #requestOtpComponent (requestOtpEvent)="handleRequestOTPEvent($event)" [isRecaptchaSolved]="isRecaptchaSolved"></app-request-otp>
                        </mat-step>
                        <mat-step>
                            <app-submit-otp #submitOtpComponent [phoneNumber]="userPhoneNumber" [dialCode]="userDialCode" [iso2Code]="userPhoneIso2Code" (submitOtpEvent)="verifyOtp($event)" (requestNewOtpEvent)="resendOtp()"></app-submit-otp>
                        </mat-step>
                        <mat-step>
                            <app-register-email #registerEmailComponent (submitEmailEvent)="handleSubmitEmailEvent($event)"></app-register-email>
                        </mat-step>
                        <mat-step>
                            <app-user-profile [countries]="countries$ | async" (notifyUserRegistration)="onNotifyUserRegistration($event)"></app-user-profile>
                        </mat-step>
                    </mat-stepper>
                </ng-template>
            </div>
            <!-- <div id="recaptcha-container"></div> -->
        </div>
    </ng-container>
</ng-template>


